export const dividerStyle = { borderColor: 'black', height: '3px' };
